import { render, staticRenderFns } from "./duoTrainingCompletionLabel.vue?vue&type=template&id=ff301f5a&scoped=true&"
import script from "./duoTrainingCompletionLabel.vue?vue&type=script&lang=js&"
export * from "./duoTrainingCompletionLabel.vue?vue&type=script&lang=js&"
import style0 from "./duoTrainingCompletionLabel.vue?vue&type=style&index=0&id=ff301f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff301f5a",
  null
  
)

export default component.exports